import * as Bricks from "./bricks/bricks.js";
import * as BricksEditable from "./bricks-editable/bricks-editable.js";

export { Bricks, BricksEditable };
export default { Bricks, BricksEditable };

window.UuContentKit = window.UuContentKit || {};
window.UuContentKit.Bricks = Bricks;
window.UuContentKit.BricksEditable = BricksEditable;

console.log(
  `${process.env.PRODUCT}-${process.env
    .VERSION} © Unicorn\nTerms of Use: https://unicorn.com/tou/${process.env.PRODUCT.toLowerCase()}`
);



// WEBPACK FOOTER //
// ./index.js